'use client';

import { useLocale } from 'src/locales/localization-provider';

import { brands } from 'src/components/carousel/utils';
import { BackToTopButton } from 'src/components/animate/back-to-top-button';
import { ScrollProgress, useScrollProgress } from 'src/components/animate/scroll-progress';

import { Clients } from '../clients';
import { CONFIG } from 'src/global-config';
import { BookingForm } from '../dashboard/home';
import { GuidingPrincipals } from '../guiding-principals';
import { OurSolutionsInclude } from '../our-solutions-include';
import { OurOperationalSolutions } from '../OurOperationalSolutions';
import { TransparencyRegulatoryAssurance } from '../transparency-regulatory-assurance';
import { WhoWeAre } from '../who-we-are';
import { BreafAbout } from '../BreafAbout';
import { DownloadApp } from '../download-app';
import { Trucks } from '../trucks';
import { Solutions } from '../Solutions';

// ----------------------------------------------------------------------

export function HomeView() {
  const pageProgress = useScrollProgress();

  // ✅ define countries data

  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />
      <BackToTopButton />

      <BookingForm />

      <WhoWeAre />
      <OurSolutionsInclude />
      <Trucks />
      <Solutions />
      {/* <TransparencyRegulatoryAssurance />
      <GuidingPrincipals />
      */}

      <Clients brands={brands} />
      <DownloadApp />

      {/* Future sections */}
    </>
  );
}
